import { Command } from 'commands/Commands';

export class ChangeMemberEmailVisibility extends Command {
  type: string = 'Member.ChangeEmailVisibility';
  priority = 100;
}
